// extracted by mini-css-extract-plugin
export default {"icon":"GoBack_icon__UCaTE"};